import React, { useMemo } from "react";
import { IoPersonOutline } from "react-icons/io5";
import { IoLocationOutline } from "react-icons/io5";
import { SlCalender } from "react-icons/sl";
import { CiMail } from "react-icons/ci";

const Personal = ({ imageSrc, userData, isInSameProject }) => {
  // Memoize the formatted birth date
  const formattedBirthDate = useMemo(() => {
    return userData?.birthDate
      ? new Date(userData.birthDate).toLocaleDateString("tr-TR")
      : "--";
  }, [userData?.birthDate]);

  // Memoize the gender text
  const genderText = useMemo(() => {
    switch (userData?.gender) {
      case "FEMALE":
        return "Kadın";
      case "MALE":
        return "Erkek";
      case "OTHER":
        return "Diğer";
      default:
        return "--";
    }
  }, [userData?.gender]);

  const shouldShowEmail = useMemo(() => {
    return isInSameProject;
  }, [isInSameProject]);

  if (!userData) return <p>Kullanıcı bulunamadı.</p>;

  return (
    <div className="detay-container">
      <div className="personal1 flex gap-4 items-center">
        <div className="relative w-[84px] h-[84px]">
          <img
            src={imageSrc}
            alt="person"
            className="w-full h-full object-cover rounded-full border-2 border-gray-300"
          />
        </div>
        <div className="flex flex-col gap-2">
          <p className="text-dark text-xl font-medium">{userData?.name}</p>
          <p className="text-base text-grayy">{userData?.position?.name}</p>
        </div>
      </div>
      <div className="personal2 flex gap-4 items-center text-grayy text-sm pt-4">
        <div className="flex gap-2 items-center">
          <span>
            <IoPersonOutline />
          </span>
          <span>{genderText}</span>
        </div>
        <div className="flex gap-2 items-center">
          <span>
            <IoLocationOutline />
          </span>
          <span>{userData?.address || "--"}</span>
        </div>
        <div className="flex gap-2 items-center">
          <span>
            <SlCalender />
          </span>
          <span>{formattedBirthDate}</span>
        </div>
      </div>
      <div className="personal3 pt-4 min-h-[150px]">
        <p className="text-grayy text-sm leading-6">
          {userData?.about || "Kullanıcı henüz bir açıklama eklemedi."}
        </p>
      </div>
      {shouldShowEmail && (
        <div className="personal4 flex gap-2 items-center text-grayy text-sm pt-4">
          <span>
            <CiMail />
          </span>
          <span>{userData?.email}</span>
        </div>
      )}
    </div>
  );
};

export default React.memo(Personal);
